import React from 'react';

import { KbjCard, KbjCardMeta, Piwik, SiteCoreDictionary } from '@eika-kortbetjening/types';

import { CardSimpleInfoAndFunctionality } from './card-simple-info-and-functionality';
import fallbackDictionary from './fallbackDictionary';

interface CardControlPanelProps {
    /** Information about the card */
    card: KbjCard;
    cardMeta: KbjCardMeta;
    /** Optional function for handling See digital card click */
    onDigitalCardClick?: () => void;
    /** Optional function for handling See PIN click */
    onSeePinClick?: () => void;
    /** Optional function for handling Open card click when reopening */
    reopenCardClick?: () => void;
    /** Sitecore dictionary */
    sitecoreDictionary?: SiteCoreDictionary;
    /** PIWIK tags */
    piwik?: Piwik;
}

export const CardControlPanel = ({
    card,
    cardMeta,
    onDigitalCardClick,
    onSeePinClick,
    reopenCardClick,
    sitecoreDictionary,
    piwik,
}: CardControlPanelProps) => {
    const dictionary = { ...fallbackDictionary, ...sitecoreDictionary };

    return (
        <CardSimpleInfoAndFunctionality
            cardMeta={cardMeta}
            card={card}
            onDigitalCardClick={onDigitalCardClick}
            onSeePinClick={onSeePinClick}
            reopenCardClick={reopenCardClick}
            dictionary={dictionary}
            piwik={piwik}
        />
    );
};
